module.exports = __webpack_public_path__ + "06_face.3514c877.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer1/06_face.png
// module id = vZUz
// module chunks = 0